/**
 * Copies the primary "Attiva" CTA from each loaded offer card
 * into the portal blue CTA block.
 */
export default class OfferPortalCtaSync {
  constructor() {
    this.portalActions = document.querySelector(
      "#offer-portal-cta .offer-online-cta__actions"
    );
    this.offersList = document.getElementById("offer-portal-list");
    this.observer = null;

    if (!this.portalActions || !this.offersList) {
      return;
    }

    this.syncFromCards();

    this.observer = new MutationObserver(() => {
      this.syncFromCards();
    });

    this.observer.observe(this.offersList, {
      childList: true,
      subtree: true,
    });
  }

  getCardActivateButtons() {
    return this.offersList.querySelectorAll(
      '.tile:not(.skeleton) .offer-card__actions > .offer-cta.btn-danger:not(.offer-cta--secondary):not([aria-hidden="true"])'
    );
  }

  isRealButton(button) {
    const label = button.querySelector("span:last-child");

    if (!label) {
      return false;
    }

    const text = label.textContent.trim();

    return text.length > 0 && !/^-+$/.test(text);
  }

  syncFromCards() {
    const cardButtons = Array.from(this.getCardActivateButtons()).filter(
      (button) => this.isRealButton(button)
    );

    if (cardButtons.length === 0) {
      this.portalActions.replaceChildren();
      return;
    }

    this.portalActions.replaceChildren();

    cardButtons.forEach((button) => {
      this.portalActions.appendChild(button.cloneNode(true));
    });
  }
}
